/**
 * Color intention that you want to used in your theme
 * @param {JsonObject} theme Theme customization object
 */

import { getStandardMicrospecCookie, setStandardMicrospecCookie } from "../Helpers/LocalPersistenceUtils";
import { getOrDefault } from "../Helpers/Utils";

// https://coolors.co/d9ed92-b5e48c-99d98c-76c893-52b69a-34a0a4-168aad-1a759f-1e6091-184e77
export default function themePalette(config) {
    const application = getOrDefault(config.application, {})
    const theme = getOrDefault(application.theme, {})
    
    // Get mode from localStorage
    const localStorageMode = getStandardMicrospecCookie('mode');
    if (!localStorageMode) {
        // Case 1: mode does not exist in localStorage
        const modeToStore = theme.mode || 'light';
        setStandardMicrospecCookie('mode', modeToStore);
        theme.mode = modeToStore;
    } else if (localStorageMode === 'light' || localStorageMode === 'dark') {
        // Case 2: mode exists with valid value (light or dark)
        theme.mode = localStorageMode;
    } else {
        // Case 3: mode exists with invalid value
        const modeToStore = theme.mode || 'light';
        setStandardMicrospecCookie('mode', modeToStore);
        theme.mode = modeToStore;
    }
    
    return theme;
}
